export const TOGGLE_OPTIONAL_MAP_ATTRIBUTION = 'TOGGLE_OPTIONAL_MAP_ATTRIBUTION';
export const CHANGE_MAP_ATTRIBUTION_POSITION = 'CHANGE_MAP_ATTRIBUTION_POSITION';
//# sourceMappingURL=constants.js.map